module.exports = __webpack_public_path__ + "static/meta_pic-6fe5113fa40c0c296fc43f24a685d752.png";